export const Puller = () => (
  <div className="sticky top-0 z-50 bg-paper py-3">
    <div className="mx-auto h-1 w-10 rounded-lg bg-grey-300" />
  </div>
);
